module.exports = __webpack_public_path__ + "img/RedAnalytics.ac2167b4.jpg";